import { OpenFeature } from '@openfeature/web-sdk';
import { useAuth } from '@/entities/user';
import { getWorkspaceId, initializeWorkspace } from '@/entities/workspace';
import { initializeFeatureFlags } from '@/shared/config/feature-flag-provider';
import { identify, setGroup, track } from '@/shared/analytics';
import { applyInitialLocale } from '@/shared/i18n/apply-initial-locale';

export async function initializeApp() {
  await useAuth.getState().signIn();
  const user = useAuth.getState().signedInUser.value;

  if (!user) {
    throw new Error('User not authenticated');
  }

  identify({
    userId: user.id,
    email: user.email,
    organizationId: user.organization.id,
    organizationName: user.organization.name,
  });
  setGroup('organization', user.organization.id);
  track('user_signed_in', {});

  initializeWorkspace(user);
  const workspaceId = getWorkspaceId();
  if (workspaceId) {
    setGroup('workspace', workspaceId);
  }

  await initializeFeatureFlags({
    id: user.id,
    email: user.email,
    organizationId: user.organization.id,
    workspaceId: getWorkspaceId(),
  });

  // Must stay after the flags resolve and before the caller renders.
  await applyInitialLocale(
    user,
    OpenFeature.getClient().getBooleanValue('language_switcher', false),
  );
}
